import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import ScrollToTop from "./components/SharedComponents/ScrollToTop";
import LandingPage from "./pages/LandingPage";
import AboutPage from "./pages/AboutUsPage";
import ArtisansPage from './pages/ArtisansPage'
import CoffeeTeaPage from "./pages/CoffeeTeaPage";
import SmoothiesPage from "./pages/SmoothiesPage";
import MocktailsPage from "./pages/MocktailsPage";
import SoftDrinksPage from "./pages/SoftDrinksPage";
import BombolonesPage from "./pages/BombolonesPage";
import BreakfastPage from './pages/BreakfastPage'
import CakesPage from "./pages/CakesPage";
import CheesecakesPage from "./pages/CheesecakesPage";
import ChilledDessertsPage from "./pages/ChilledDessertsPage";
import TresLechesPage from "./pages/TresLechesPage";
import GelatoPage from "./pages/GelatoPage";
import CookiesPage from "./pages/CookiesPage";
import CupcakesPage from './pages/CupcakesPage'
import MainsPage from './pages/MainsPage'
import PastaPage from "./pages/PastaPage";
import PiesTartsPage from './pages/PiesTartsPage'
import SaladsPage from "./pages/SaladsPage";
import SandwichesPage from "./pages/SandwichesPage";
import SavoryPiesPage from "./pages/SavoryPiesPage";
import ViennoiseriePage from "./pages/ViennoiseriePage";
import DanishPastriesPage from "./pages/DanishPastriesPage";
import ContactUsPage from "./pages/ContactUsPage";
import AtelierPage from "./pages/AtelierPage";
import CateringPage from "./pages/CateringPage";
import GalleryPage from "./pages/GalleryPage";
import AdminLogin from "./pages/Admin/AdminLogin";
import AdminDashboard from "./pages/Admin/AdminDashboard";
import PrivacyPolicyPage from "./pages/PrivacyPolicyPage";
import TermsAndConditionsPage from "./pages/TermsAndConditionsPage";

const isAuthenticated = () => {
  return sessionStorage.getItem("authToken") !== null;
};

const ProtectedRoute = ({ element }) => {
  return isAuthenticated() ? element : <Navigate to="/admin" />;
};

const App = () => {
  return (
    <Router>
      <ScrollToTop />
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/artisans" element={<ArtisansPage />} />
          <Route path="/coffee-tea" element={<CoffeeTeaPage />} />
          <Route path="/someethies-milkshakes" element={<SmoothiesPage />} />
          <Route path="/juices-mocktails" element={<MocktailsPage />} />
          <Route path="/water-softdrinks" element={<SoftDrinksPage />} />
          <Route path="/bombolones" element={<BombolonesPage />} />
          <Route path="/breakfast" element={<BreakfastPage />} />
          <Route path="/cakes" element={<CakesPage />} />
          <Route path="/cheesecakes" element={<CheesecakesPage />} />
          <Route path="/chilled-desserts" element={<ChilledDessertsPage />} />
          <Route path="/tres-leches" element={<TresLechesPage />} />
          <Route path="/gelato" element={<GelatoPage />} />
          <Route path="/cookies-bars" element={<CookiesPage />} />
          <Route path="/cupcakes" element={<CupcakesPage />} />
          <Route path="/mains" element={<MainsPage />} />
          <Route path="/pasta" element={<PastaPage />} />
          <Route path="/pies-tarts" element={<PiesTartsPage />} />
          <Route path="/salads" element={<SaladsPage />} />
          <Route path="/sandwiches" element={<SandwichesPage />} />
          <Route path="/savory-pies" element={<SavoryPiesPage />} />
          <Route path="/viennoiserie" element={<ViennoiseriePage />} />
          <Route path="/danish-pastries" element={<DanishPastriesPage />} />
          <Route path="/contact-us" element={<ContactUsPage />} />
          <Route path="/atelier" element={<AtelierPage />} />
          <Route path="/catering" element={<CateringPage />} />
          <Route path="/gallery" element={<GalleryPage />} />
          <Route path="/admin" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={<ProtectedRoute element={<AdminDashboard />} />}/>
          <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
          <Route path="/terms-and-conditions" element={<TermsAndConditionsPage />} />
        </Routes>
    </Router>
  );
};

export default App;
